import React, { useEffect, useState } from 'react';
import { Table, Button, Modal, Form, Input, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getCategories, createCategory, updateCategory, deleteCategory } from '../../../redux/actions/category';
import { DeleteOutlined } from '@ant-design/icons';
import ProtectedLayout from '../../../layouts/ProtectedLayout';

const Categories = () => {
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingCategory, setEditingCategory] = useState<any>(null);
    const dispatch = useDispatch();
    const { categories } = useSelector((state: any) => state.categories);

    useEffect(() => {
        dispatch<any>(getCategories());
    }, [dispatch]);

    const showModal = (category?: any) => {
        if (category) {
            setEditingCategory(category);
            form.setFieldsValue(category);
        } else {
            setEditingCategory(null);
            form.resetFields();
        }
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
        setEditingCategory(null);
    };

    const handleSubmit = async (values: any) => {
        try {
            if (editingCategory) {
                await dispatch<any>(updateCategory(editingCategory._id, values));
                message.success('Kategori başarıyla güncellendi');
            } else {
                await dispatch<any>(createCategory(values));
                message.success('Kategori başarıyla oluşturuldu');
            }
            handleCancel();
        } catch (error) {
            message.error('Bir hata oluştu');
        }
    };

    const handleDelete = async (id: string) => {
        try {
            await dispatch<any>(deleteCategory(id));
            message.success('Kategori başarıyla silindi');
        } catch (error) {
            message.error('Bir hata oluştu');
        }
    };

    const columns: any = [
        {
            title: 'İsim',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Açıklama',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '',
            key: 'actions',
            width: 200,
            align: 'right',
            render: (_: any, record: any) => (
                <div className="space-x-2">
                    <Button type="primary" onClick={() => showModal(record)}>
                        Düzenle
                    </Button>
                    <Button type="primary" danger shape="circle" icon={<DeleteOutlined />} onClick={() => handleDelete(record._id)} />
                </div>
            ),
        },
    ];

    return (
        <ProtectedLayout>
            <div className="p-6">
            <div className="flex justify-between mb-4">
                <h1 className="text-2xl font-bold">Kategoriler</h1>
                <Button type="primary" onClick={() => showModal()}>
                    Yeni Kategori Ekle
                </Button>
            </div>

            <Table columns={columns} dataSource={categories} rowKey="_id" />

            <Modal
                title={editingCategory ? 'Kategori Düzenle' : 'Yeni Kategori Ekle'}
                open={isModalVisible}
                onCancel={handleCancel}
                footer={null}
            >
                <Form form={form} onFinish={handleSubmit} layout="vertical">
                    <Form.Item
                        name="name"
                        label="Kategori Adı"
                        rules={[{ required: true, message: 'Lütfen kategori adını girin' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="description"
                        label="Açıklama"
                    >
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item>
                        <div className="flex justify-end space-x-2">
                            <Button onClick={handleCancel}>
                                İptal
                            </Button>
                            <Button type="primary" htmlType="submit">
                                {editingCategory ? 'Güncelle' : 'Oluştur'}
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
        </ProtectedLayout>
    );
};

export default Categories; 